$(function () {
  'use strict';

  function getParameterByName(name, url) {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  function objWithKeyValue(key, value) {
    var obj = {};
    obj[key] = value;
    return obj;
  }

  $.easing.easeOutQuint = function (x, t, b, c, d) {
    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
  };

  $('[data-provide=local-scroll]').localScroll({
    duration: 1000,
    easing: 'easeOutQuint'
  });

  Vue.transition('collapse', {
    enter: function (el, done) {
      // element is already inserted into the DOM
      // call done when animation finishes.
      $(el)
        .css('display', 'none')
        .slideDown(400, done);
    },
    enterCancelled: function (el) {
      $(el).stop();
    },
    leave: function (el, done) {
      // same as enter
      $(el).slideUp(400, done);
    },
    leaveCancelled: function (el) {
      $(el).stop();
    }
  });

  new Vue({
    el: '#programs',

    data: {
      data: [],
      sortKey: '',
      filterKey: '',
      searchQuery: '',
      reversed: false,
      page: 1,
      total: 0,
      perPage: 30,
      filterIds: [],
      advancedFilters: false,
      advancedSearch: false,
      palavras: {},
      coleccoes: {},
      faixasEtarias: {},
      areasPsicologia: {}
    },

    compiled: function () {
      var self = this;

      self.total = this.data.length;

      self.getFilters();
      self.fetchData();

      self.$watch('advancedSearch', function () {
        localStorage.setItem('advancedSearch', self.advancedSearch);
      });
    },

    computed: {
      paginateData: function () {
        var index = (this.page - 1) * this.perPage;
        return this.filterData.slice(index, index + this.perPage);
      },

      pages: function () {
        var total = [],
          i = this.page;

        if (i === this.pageLength) {
          while (total.length <= 5 && i >= 1) {
            total.push(i);
            i--;
          }
        } else if ((i + 2) > this.pageLength) {
          while (total.length < 4 && i >= 1) {
            total.push(i);
            i--;
          }
        } else if ((i + 2) <= this.pageLength) {
          while (total.length < 3 && i >= 1) {
            total.push(i);
            i--;
          }
        }
        i = this.page + 1;
        while (i <= this.pageLength && total.length < 5) {
          total.push(i);
          i++;
        }
        return total.sort(function (a, b) {
          return a - b;
        });
      },
      pageLength: function () {
        return Math.ceil(this.filterData.length / this.perPage);
      },
      filterData: function () {
        var self = this;

        self.data = self.$options.filters.orderBy(self.data, self.sortKey, self.reversed);

        var data = self.$options.filters.filterBy(self.data, self.filterKey, 'in', 'nome', 'coleccao');

        if (self.advancedFilters) {
          data = data.filter(function (item) {
            return self.filterIds.indexOf(item.id) >= 0;
          });
        }

        return data;
      }
    },

    methods: {
      sortBy: function (e, key) {

        var self = this;

        if (key === self.sortKey) {
          self.reversed = !self.reversed;
        } else {
          self.reversed = false;
        }

        self.sortKey = key;
        e.preventDefault();
      },
      fetchData: function () {
        var xhr = new XMLHttpRequest();
        var self = this;
        xhr.open('GET', '/repositorio/api/estudos');
        xhr.onload = function () {
          self.data = JSON.parse(xhr.responseText);
        };
        xhr.send();
      },
      getPage: function (e, page) {
        e.preventDefault();

        var self = this;

        if (page <= self.pageLength && page > 0) {
          self.page = page;
        }
      },
      quickSearch: function (e, searchQuery) {
        e.preventDefault();

        var self = this;

        self.filterKey = searchQuery;
        self.saveFilters();
      },
      clearQuickSearch: function (e) {
        e.preventDefault();
        var self = this;

        self.searchQuery = '';
        self.filterKey = '';
        self.saveFilters();
      },
      search: function () {
        var self = this;

        $.getJSON(
          '/repositorio/api/estudos-filtered',
          {
            palavras: self.palavras,
            coleccoes: self.coleccoes,
            faixasEtarias: self.faixasEtarias,
            areasPsicologia: self.areasPsicologia
          },
          function (data) {
            self.filterIds = data;
            self.advancedFilters = true;

            self.saveFilters();
          }
        );
      },
      saveFilters: function () {
        var self = this;
        localStorage.setItem('filterKey', self.filterKey);
        localStorage.setItem('palavras', JSON.stringify(self.palavras));
        localStorage.setItem('coleccoes', JSON.stringify(self.coleccoes));
        localStorage.setItem('faixasEtarias', JSON.stringify(self.faixasEtarias));
        localStorage.setItem('areasPsicologia', JSON.stringify(self.areasPsicologia));
      },
      getFilters: function () {
        var self = this;

        var query = $('#Query').val();
        if (query.length || localStorage.filterKey) {
          // ordem interessa, pois o que vem da página principal deve sobrepôr-se ao que está guardado
          self.filterKey = query || localStorage.filterKey;
          self.searchQuery = query || localStorage.filterKey;
        }

        var palavra = getParameterByName('palavra');
        if (palavra || localStorage.palavras) {
          self.palavras = palavra ? objWithKeyValue(palavra, true) : JSON.parse(localStorage.palavras);
        }

        var coleccao = getParameterByName('coleccao');
        if (coleccao || localStorage.coleccoes) {
          self.coleccoes = coleccao ? objWithKeyValue(coleccao, true) : JSON.parse(localStorage.coleccoes);
        }

        if (localStorage.faixasEtarias) {
          self.faixasEtarias = JSON.parse(localStorage.faixasEtarias);
        }

        if (localStorage.areasPsicologia) {
          self.areasPsicologia = JSON.parse(localStorage.areasPsicologia);
        }

        if (palavra || coleccao || localStorage.advancedSearch === 'true') {
          self.advancedSearch = true;
          self.search();
        }
      },
      clearSearch: function () {
        var self = this;
        var els = [self.palavras, self.coleccoes, self.faixasEtarias, self.areasPsicologia];

        for (var i = 0; i < els.length; ++i) {
          var el = els[i];
          for (var prop in el) {
            if (el.hasOwnProperty(prop)) {
              el[prop] = false;
            }
          }
        }

        self.filterIds = [];
        self.advancedFilters = false;
        self.saveFilters();
      }

    },

    filters: {
      percentage: function (value) {
        var percentage = value * 100;

        return (Math.round(percentage * 100) / 100) + '%';
      }
    }
  });
});